export type REQUEST_METHOD_TYPES = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
export enum WEB_HOOK_REQUEST_METHOD_TYPES {
  'GET' = 'GET',
  'POST' = 'POST',
  'PUT' = 'PUT',
  'DELETE' = 'DELETE',
  'PATCH' = 'PATCH'
}
